// RosterView.js — Roster view (people on the clock).
import React from 'react';
import { T } from '../lib/crewTokens';
import { CrewGlyph, Avatar, ClockBadge, LiveDuration, OTBadge } from '../atoms/CrewAtoms';

const CR = T;

// ── Roster: every member, grouped by crew ────────────────────
function RosterView({ rows, selected, onSelect, glyph }) {
  return (
    <div className="card" style={{ overflow: 'auto', maxHeight: '100%' }}>
      <table className="crew-ctbl">
        <thead><tr>
          <th style={{ paddingLeft: 14 }}>Crew</th><th>Member</th><th>Role</th><th>Clock status</th>
          <th>On clock</th><th>Location</th><th style={{ textAlign: 'right' }}>Tickets</th><th style={{ paddingRight: 14, textAlign: 'right' }}>OT</th>
        </tr></thead>
        <tbody>
          {rows.map((c) => c.members.map((m, mi) => {
            const isSel = selected && selected.id === c.id;
            return (
              <tr key={c.id + mi} className={isSel ? 'selected' : ''} onClick={() => onSelect(c)} style={{ cursor: 'pointer' }}>
                <td style={{ paddingLeft: 14 }}>
                  {mi === 0 ? (
                    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 7 }}>
                      <CrewGlyph level={c.status.level} variant={glyph} size={16} />
                      <span><span style={{ fontWeight: 800, fontSize: 12 }}>{c.name}</span><span style={{ fontFamily: CR.mono, fontSize: 9.5, color: CR.muteSoft, marginLeft: 6 }}>{c.vehicle.no}</span></span>
                    </span>
                  ) : <span style={{ display: 'inline-block', width: 16, borderLeft: `2px solid ${CR.line}`, marginLeft: 8, height: 14 }}></span>}
                </td>
                <td><span style={{ display: 'inline-flex', alignItems: 'center', gap: 7 }}><Avatar name={m.name} initials={m.initials} color={m.color} size={22} /><span style={{ fontWeight: 600, fontSize: 12 }}>{m.name}</span></span></td>
                <td style={{ fontSize: 11, color: CR.mute }}>{m.role}</td>
                <td><ClockBadge status={m.status} since={m.since} dense /></td>
                <td style={{ fontFamily: CR.mono, fontSize: 11, color: CR.ink2 }}><LiveDuration since={m.clockIn} /></td>
                <td style={{ fontSize: 11, color: CR.ink2, maxWidth: 200, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{mi === 0 ? c.location.label : '—'}</td>
                <td style={{ textAlign: 'right', fontFamily: CR.mono, fontSize: 11 }}>{mi === 0 ? <>{c.ticketsDone}<span style={{ color: CR.muteSoft }}>/{c.ticketsScheduled}</span></> : ''}</td>
                <td style={{ paddingRight: 14, textAlign: 'right' }}>{mi === 0 ? <OTBadge ot={c.ot} dense /> : ''}</td>
              </tr>
            );
          }))}
        </tbody>
      </table>
      {rows.length === 0 && <div style={{ padding: 40, textAlign: 'center', color: CR.muteSoft, fontSize: 12 }}>No crews match these filters.</div>}
    </div>
  );
}

export { RosterView };
